import { useState } from "react";
import { useAuth } from "@adapters/hooks";
import { apiClient } from "@api/apiClient";
import { useNotificationContext } from "@hooks/useNotificationContext";
import type { LoginFormValues } from "@interfaces/login.interface";

export const useLogin = () => {
  const [loading, setLoading] = useState(false);
  const auth = useAuth();
  const { error: showError } = useNotificationContext();

  const handleSubmit = async (values: LoginFormValues) => {
    let errorShown = false;
    try {
      setLoading(true);
      
      const result = await auth.login(
        values.username,
        values.password,
        (errorMessage) => {
          errorShown = true;
          showError("Đăng nhập thất bại", errorMessage, 4);
        }
      );
      
      if (result.token) {
        apiClient.setToken(result.token);
      }
    } catch (error) {
      console.error("Login error:", error);
      if (!errorShown) {
        showError(
          "Đăng nhập thất bại",
          error instanceof Error 
            ? error.message || "Vui lòng thử lại."
            : "Vui lòng thử lại.",
          4
        );
      }
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    handleSubmit,
  };
};

